export const COMPANY_ADMIN_SET_USERS = 'COMPANY_ADMIN_SET_USERS';
export const COMPANY_ADMIN_EDIT_POST = 'COMPANY_ADMIN_EDIT_POST';
export const COMPANY_ADMIN_REMOVE_POST = 'COMPANY_ADMIN_REMOVE_POST';
export const COMPANY_ADMIN_REMOVE_USER_FROM_COMPANY = 'COMPANY_ADMIN_REMOVE_USER_FROM_COMPANY';
export const COMPANY_ADMIN_SET_NEW_COMPANY_ADMIN = 'COMPANY_ADMIN_SET_NEW_COMPANY_ADMIN';
export const COMPANY_ADMIN_REMOVE_USER_FROM_BRAND = 'COMPANY_ADMIN_REMOVE_USER_FROM_BRAND';
export const COMPANY_ADMIN_ADD_USER_TO_BRAND = 'COMPANY_ADMIN_ADD_USER_TO_BRAND';
export const EDIT_BRAND = 'EDIT_BRAND';